'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { useAnalytics } from '~/hooks/use-analytics'

/**
 * Track thời gian user ở lại mỗi trang.
 * Gửi event `time_on_page` khi rời trang hoặc route thay đổi.
 */
export function TimeOnPageTracker() {
  const pathname = usePathname()
  const startRef = useRef(Date.now())
  const { trackTimeOnPage } = useAnalytics()

  useEffect(() => {
    startRef.current = Date.now()

    const handleLeave = () => {
      const seconds = Math.round((Date.now() - startRef.current) / 1000)
      if (seconds >= 2) trackTimeOnPage(seconds)
    }

    window.addEventListener('beforeunload', handleLeave)
    return () => {
      handleLeave()
      window.removeEventListener('beforeunload', handleLeave)
    }
  }, [pathname])

  return null
}
